import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export const I18n = ({ children }) => {
    const { t, i18n } = useTranslation();

    if (typeof children !== 'function') {
        console.warn('I18n expects children to be a function. Received:', children);
        return children; // Zwróć children jako fallback, jeśli nie jest funkcją
    }

    return children(t, i18n);
};

I18n.propTypes = {
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
};

export const T = ({ id, ...rest }) => {
    const { t } = useTranslation();
    return <>{t(id, rest)}</>;
};

T.propTypes = {
    id: PropTypes.string.isRequired,
};
export { I18nContext } from '../../context/I18nContext';
export default I18n;